import service from '@/middleware'

const zoneApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     */
    async findAllPaginated(enterprises, pageSize, pageNumber, headers) {
        const url = pageSize != null && pageNumber != null
            ? `/api/zone/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/zone/all?headers=${headers}`
        const response = await service.http.post(url, enterprises)
        return response
    },
    async findAll(enterprises, geometry = true, category = '') {
        const response = await service.http.post(
            `/api/zone/all?geometry=${geometry}&category=${category}`, enterprises)
        return response
    },
    /**
     * Total de zonas para el paginador de la tabla del ABM
     */
    async getTotal(enterprises) {
        const result = await service.http.post(`/api/zone/total`, enterprises)
        return result
    },
    /**
     * Para obtener una zona con el id enviado como param
     * @param {*} zoneId
     */
    async getZone(zoneId) {
        const result = await service.http.get(`/api/zone/${zoneId}`)
        return result
    },
    /**
     * Para crear una nueva zona
     * @param {*} zoneDto
     */
    async create(zoneDto) {
        const result = await service.http.post(`/api/zone/create`, zoneDto)
        return result
    },
    /**
     * Para actualizar una zona
     * @param {*} zoneDto
     */
    async update(zoneDto) {
        const result = await service.http.put(`/api/zone/update`, zoneDto)
        return result
    },
    /**
     * Para eliminar una zona
     * @param {*} id
     */
    async deleteOne(id) {
        const result = await service.http.delete(`/api/zone/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany(ids) {
        const result = await service.http.put(`/api/zone/multiple-delete`, ids)
        return result
    },

    async getCategories(enterpriseId) {
        return await service.http.get(`/api/zone/categories/${enterpriseId}`)
    },

    /**
     * Valida que para actualizar el valor "zonas" del selector en el diálogo AMB categorías no existan zonas con dicha categoría
     */
    async validateZones(categoryId) {
        const result = await service.http.get(`/api/zone/count-by-category/${categoryId}`)
        return result
    }
}

export default zoneApi
